import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Service } from '../../../models/service.model';
import { api } from '../../../models/api-url.model';
import { ApiService } from '../api';

@Injectable({
  providedIn: 'root',
})
export class ServiceService {
  private readonly apiService = inject(ApiService);

  getServices(): Observable<Service[]> {
    return this.apiService.get(api.servicesURL);
  }

  getServicesInService(): Observable<any> {
    return this.apiService.get(`${api.servicesURL}/status/inservice`);
  }
}
